import { Pagination } from '@nextui-org/react';
import styled from 'styled-components';

import { ThemeProp } from '../../theme/Themes';

export const PaginationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 4.3rem;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    justify-content: center;
    margin-top: 1rem;
  }
`;

export const StyledPagination = styled(Pagination)`
  .nextui-pagination-item {
    background-color: ${(props: ThemeProp) => props.theme.colors.white};
    color: ${(props: ThemeProp) => props.theme.colors.black};
    font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
    border-radius: ${(props: ThemeProp) => props.theme.borderRadius};
  }

  .nextui-pagination-highlight {
    background-color: ${(props: ThemeProp) => props.theme.colors.white};
    border-radius: ${(props: ThemeProp) => props.theme.borderRadius};
  }

  .nextui-pagination-highlight--active {
    border: 1px solid ${(props: ThemeProp) => props.theme.colors.mainColor};
    background-color: ${(props: ThemeProp) => props.theme.colors.white};
  }
  .nextui-pagination-item-active {
    box-shadow: none;
    .nextui-pagination-item-content {
      font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
      color: ${(props: ThemeProp) => props.theme.colors.mainColor};
    }
  }

  .nextui-pagination-item-disabled {
    .nextui-pagination-item-content {
      opacity: 0.2;
    }
  }
`;
